import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar"; 
import BannerSection from "./pages/BannerSection";
import TravelSection from "./pages/TravelSection";
import TourPackagesSection from "./pages/TourPackagesSection";
import TaxiServices from "./pages/TexiServices";
import ClientReviews from "./pages/ClientReview";
import AboutUs from "./pages/AboutUs";
import "./App.css"; 
import Footer from './components/Footer';
import TexiServices from "./pages/TexiServices";
import HotelBooking from "./pages/HotelBooking";
import PindDaan from "./pages/PindDaan";
import BookCruise from "./pages/BookCruise";
import Contact from "./pages/Contact";
import PolicyPage from "./pages/PolicyPage";
import TermsService from "./pages/TermsService";
import CancellationPolicy from "./pages/CancellationPolicy";
import ContactButtons from "./pages/ContactButtons";
// Home Component (सभी sections एक साथ)
const Home = () => {
  return (
    <>
      <BannerSection/>
      <TravelSection/>
      <TourPackagesSection/>
      <TaxiServices/>
      <ClientReviews/>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/tour-packagesection" element={<TourPackagesSection/>}/>
          <Route path="/texi-services" element={<TexiServices/>}/>
          <Route path="/hotel-booking" element={<HotelBooking/>}/>
          <Route path="/pind-daan" element={<PindDaan/>}/>
          <Route path="/book-cruise" element={<BookCruise/>}/>
          <Route path="/contact" element ={< Contact/>}/>
          <Route path="/policy-page"element={<PolicyPage/>}/>
          <Route path="terms-service"element={<TermsService/>}/>
          <Route path="cancellation-policy"element={<CancellationPolicy/>}/>
  
        </Routes>
        <ContactButtons/>
        <Footer />
      </div>
    </Router>
  );
}

export default App;